

export let AuthApi = {
    BASEURL: "https://api.gympin.ir/",
    // BASEURL: "http://192.168.1.108:8080/api/",
    // BASEURL: "https://api.gympin.ir/",
    BASECHATURL: "https://ws.gympin.ir/",
};
export let Api_url = {
    Account: {
        LOGIN_URL: "v1/account/login",
        SEND_SMS_URL: "v1/account/sendsms",
        REFRESH_TOKEN: "v1/account/refreshToken",
        REGISTER_WITH_INVITE_CODE: "v1/account/registerByInviteCode",
        GET_INVITE_CODES: "v1/account/userInviteCodes"
    },
    configs: {
        WebAppSplash: "v1/configs/WebAppSplash"
    },
    gatewayApplication: {
        query: "v1/GatewayApplication/query",
    },
    suggest: {
        query: "v1/suggest/query",
    },
    qrCode: {
        getCode: "v1/qrCode/getCode",
    },
    giftCredit: {
        checkStatus: "v1/giftCredit/checkStatus"
    },
    homePage: {
        GetHome: "v1/pages/getHome",
        GetPageByData: "v1/pages/getPageByData",
    },
    gift: {
        claim: "v1/giftCredit/claimGift"
    },
    invoice: {
        update: "v1/invoice/update",
        delete: "v1/invoice/delete",
        getAll: "v1/invoice/getAll",
        getBasketByUserId: "v1/invoice/getBasketByUserId",
        query: "v1/invoice/query",
        getHowToPay: "v1/invoice/getUserHowToPay",
        changeInvoiceBuyableCount: "v1/invoice/changeInvoiceBuyableCount",
        userCheckout: "v1/invoice/userCheckout",
        addSubscribe: "v1/invoice/addSubscribe",
        deleteBuyable: "v1/invoice/deleteBuyable",
        applyPeriodicDiscount: "v1/invoice/applyPeriodicDiscount",
        removePeriodicDiscount: "v1/invoice/removePeriodicDiscount",
    },
    placeRate: {
        add: "v1/placeRate/add",
    },
    placeComment: {
        add: "v1/placeComment/add",
        query: "v1/placeComment/query"
    },
    increaseUserDeposit: {
        requestIncreaseUserDeposits: "v1/increaseUserDeposit/requestIncreaseUserDeposits",
        query: "v1/increaseUserDeposit/query",
    },
    location: {
        query: "v1/location/query"
    },
    multimedia: {
        add: "v1/multimedia/add",
        categoryGetById: "v1/multimediacategory/getById"
    },
    Notification: {
        getUserNotifications: "v1/Notification/getUserNotifications"
    },
    NotificationSubscription: {
        add: "v1/NotificationSubscription/add"
    },
    optionOfPlace: {
        GET_BY_PLACE_ID: "v1/OptionOfPlace/getByPlaceId",
    },
    placeAbout: {
        getByPlaceId: "v1/placeAbout/getByPlaceId",
        getAllAboutByPlaces: "v1/placeAbout/getAllAboutByPlaces",
    },
    gym: {
        GET_ALL: "v1/gym/getAll",
        GET_BY_ID: "v1/gym/getById",
        query: "v1/gym/query",
    },
    TicketSubscribe: {
        getById: "v1/TicketSubscribe/getById",
        getByPlace: "v1/TicketSubscribe/getByPlace",
        query: "v1/TicketSubscribe/query",
    },
    Link: {
        getByCode: "v1/link/getByCode",
    },
    TicketCourses: {
        getById: "v1/TicketCourse/getById",
        getActiveTimesByTicketCourse: "v1/TicketCourse/getActiveTimesByTicketCourse"
    },
    support: {
        ADD: "v1/support/add",
        ADD_MESSAGE: "v1/support/addMessage",
        GET_BY_ID: "v1/support/getById",
        setMessagesRead: "v1/support/setMessagesRead",
        query: "v1/support/query"
    },
    Chat: {
        endpoint: "GympinChatEndPoint"
    },
    ws: {
        messages: "v1/ws/messages",
        markRead: "v1/ws/markRead"
    },
    purchasedSubscribe: {
        ADD: "v1/purchasedSubscribe/add",
        query: "v1/purchasedSubscribe/query",
        getByKey: "v1/purchasedSubscribe/getByKey",
        GET_BY_USER: "v1/purchasedSubscribe/getByUser",
        exitRequest: "v1/purchasedSubscribe/exitRequest",
        enterRequest: "v1/purchasedSubscribe/enterRequest",
        addEnterToSubscribe: "v1/purchasedSubscribe/addEnterToSubscribe",
    },
    purchasedCourse: {
        ADD: "v1/purchasedCourse/add",
        GET_BY_USER: "v1/purchasedCourse/getByUser",
        getById: "v1/purchasedCourse/getById",
        exitRequest: "v1/purchasedCourse/exitRequest",
        enterRequest: "v1/purchasedCourse/enterRequest"
    },
    TransactionUser: {
        query: "v1/TransactionUser/query",
        getAll: "v1/TransactionUser/getAll",
        getById: "v1/TransactionUser/getById",
    },
    user: {
        get_My_Info: "v1/user/getMyInfo",
        UPDATE_USER: "v1/user/update",
        UPDATE_AVATAR: "v1/user/updateUserAvatar",
        setUserSettings: "v1/user/setUserSettings",
        checkUsernameAvailable: "v1/user/checkUsernameAvailable",
        getMyCredits: "v1/user/getMyCredits",
        query: "v1/user/query",
    }
};
